angular.module('qkr').filter('emptyToBottom', () => function(array, key, sorter) {
    	if (!angular.isArray(array)) return;
        
        const present = array.filter((item) => item[key]);
        const empty = array.filter((item) => !item[key]);
        
        return sorter !== key ? array : present.concat(empty);
    });



// WEBPACK FOOTER //
// ./src/filters/empty_to_bottom.js